import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SelectUI from '../../../widgets/input/SelectUI'
import SearchUI from '../../../widgets/input/SearchUI'
import CardUI from '../../../widgets/layout/CardUI'
import { Link } from 'react-router-dom'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import MonitoringActionModalSF from './MonitoringActionModalSF'
import MonitoringIntelligencePageNavUI from './MonitoringIntelligencePageNavUI'
import EMIDetailsDialogUI from './EMIDetailsDialogUI'
import AccountSummaryDialog from './AccountSummaryDialog'
import whatsappIcon from '../../../assets/finapp/whatsapp.png'
import React, { useState, useEffect } from 'react';
import './MonitoringIntelligence.css';
import PenalChargeDetailsDialogUI from './PenalChargeDetailsDialogUI'
import LegalChargeDetailsDialogUI from './LegalChargeDetailsDialogUI'
import PenalChargeDialogUI from './PenalChargeDialogUI '
import DsraDipDetailsDialogUI from './DsraDipDetailsDialogUI'
import DsraClauseDialogUI from './DsraClauseDialogUI'
import NoticeCreationModal from './NoticeCreationModal'
import { is } from 'date-fns/locale'

const MonitoringIntelligenceRetailUI = ({
  context, errorList, chequeBounceList, processedData, onRefreshClick,
  selectedStatus, onStatusChange, onSearchFilterChange, onLrnFilterChange, searchFilter, lrnFilter, onDownloadReport,
  getStatusDisplayValue, onDocDownloadClick,
  isUpdateMode, onUpdateMode, onUpdateModeClose, currentItem, yearMonth, onPreviousClick, onNextClick,
  selectedReportType, onReportTypeChange,
  onEmiDetailsClick, closeEmiDetailsModal, isEmiDetailsModalOpen, currentEmiDetails,
  onCreateWhatsappApproval, onCreateEmailApproval,
  onViewAccountSummary, isAccountSummaryOpen, currentAccountSummary, closeAccountSummaryModal,
  messageApprovalList, setOpenPenalClauseDialog, isPenalClauseModalOpen, closePenalClauseModal, currentPenalClauses,
  onLegalChargeDetailsClick, isLegalDetailsModalOpen, closeLegalDetailsModal, currentLegalDetails, onPenalChargeDetailsClick,
  setOpenDsraClauseDialog, isDsraClauseModalOpen, closeDsraClauseModal, currentDsraClause,
  isPenalDetailModalOpen, closePenalDetailModal, currentPenalDetails, onDsraShortfallDetailsClick, isDsraDetailModalOpen, closeDsraDetailModal, currentDsraDetails,
  isNoticeModalOpen, onOpenNoticeModal, onCloseNoticeModal, onCreateNoticeDraft, noticeModalType, noticeModalAccountId, noticeCreationLoading, nonFinancialComplianceData


}) => {
  const isAnyDialogOpen = isEmiDetailsModalOpen || isAccountSummaryOpen || isUpdateMode || isPenalClauseModalOpen || isLegalDetailsModalOpen || isPenalDetailModalOpen
    || isDsraDetailModalOpen || isDsraClauseModalOpen || isNoticeModalOpen;

  return (
    <SuperUserHomePageUI
      context={context} className='pg_su_cr'
      topnav='monitoringIntelligence' page='monitoringIntelligence'
      centered={!chequeBounceList || !errorList}
      dimension='w1600'
    >
      {
        (!chequeBounceList || !errorList) &&
        <SpinnerComponentUI />
      }

      {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

      {
        chequeBounceList &&
        <div>
          <div className="g_fixed_header_container" style={{
            position: isAnyDialogOpen ? 'static' : 'sticky',
            top: 0,
            zIndex: 1000,
            backgroundColor: 'white',
            borderBottom: '1px solid #e0e0e0',
            paddingBottom: '10px'
          }}>
            <LRTableActionsUI
              location='top'
              left={
                <div>
                  <span className='g_flex_left g_flex_h'>
                    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh Page' />
                    {/* <IconButtonUI icon='icon-download' onClick={onDownloadReport} label='Download Report' /> */}
                    <span className='g_m_left_100 g_large'><b>Monitoring Intelligence, {yearMonth.monthName} {yearMonth.year}</b></span>
                  </span>
                  {/* <div className='g_flex_v' style={{ justifyContent: 'flex-end' }}>
                    <div className='g_m_left_100 g_flex_h' >
                      <p className='g_error' style={{ marginRight: '20px' }}>Red: Notice Sent</p>
                      <p className='g_info' style={{ marginRight: '20px' }}>Blue: Dsra dip</p>
                      <p className='g_success'>Green: No Compliances</p>
                    </div>
                  </div> */}
                </div>
              }
              right={
                <span className='g_text_left'>
                  <div className='g_flex_v'>
                    <div className='g_flex_h g_flex_right'>
                      <Link to='#' onClick={onPreviousClick}>Previous</Link>
                      <span className='g_m_left_100' />
                      <Link to='#' onClick={onNextClick}>Next</Link>
                    </div>
                    <div className='g_flex_h g_m_top_20'>
                      <div className='g_flex_v' >
                        <SearchUI value={searchFilter} onChange={onSearchFilterChange} placeholder="Search by account" />
                        <span className='g_muted g_small'>Search by account</span>
                      </div>
                      <div className='g_flex_v' >
                        <SearchUI value={lrnFilter} onChange={onLrnFilterChange} placeholder="Search by LRN" />
                        <span className='g_muted g_small'>Search by LRN</span>
                      </div>
                      <div className='g_flex_v g_m_left_50'>
                        <SelectUI
                          selectedKey={selectedReportType}
                          optionList={[
                            { label: 'All', value: 'all' },
                            { label: 'NACH Failure', value: 'nachFailure' },
                            { label: 'Legal Charge', value: 'legalCharge' },
                            { label: 'Penal Charge', value: 'penalCharge' },
                            { label: 'DSRA Shortfall', value: 'dsraShortfall' },
                            { label: 'EMI', value: 'emi' },
                            { label: 'Cheque Bounce', value: 'chequeBounce' }
                          ]}
                          onChange={onReportTypeChange}
                          placeholder="Report Type"
                        />
                        <span className='g_muted g_small'>Filter by report type</span>
                      </div>
                      <div className='g_flex_v g_m_left_50' >
                        <SelectUI
                          selectedKey={selectedStatus}
                          optionList={[
                            { label: 'All', value: 'all' },
                            { label: 'Open', value: 'open' },
                            { label: 'Close', value: 'close' },
                            { label: 'Pending For Closure', value: 'pending_for_closure' }
                          ]}
                          onChange={onStatusChange}
                          placeholder="Status"
                        />
                        <span className='g_muted g_small'>Filter by status</span>
                      </div>
                    </div>
                  </div>
                </span>
              }
            />

            <MonitoringIntelligencePageNavUI
              context={context}
              page='monitoringIntelligence_retail'
            />
          </div>

          <div style={{ marginTop: '10px' }}>
            <MonitoringIntelligenceTableUI
              processedData={processedData}
              context={context}
              getStatusDisplayValue={getStatusDisplayValue}
              onDocDownloadClick={onDocDownloadClick}
              onUpdateMode={onUpdateMode}
              onEmiDetailsClick={onEmiDetailsClick}
              onLegalChargeDetailsClick={onLegalChargeDetailsClick}
              onPenalChargeDetailsClick={onPenalChargeDetailsClick}
              onDsraShortfallDetailsClick={onDsraShortfallDetailsClick}
              onCreateWhatsappApproval={(accountId) => onOpenNoticeModal(accountId, 'whatsapp')}
              onCreateEmailApproval={(accountId) => onOpenNoticeModal(accountId, 'email')}
              onViewAccountSummary={onViewAccountSummary}
              isAnyDialogOpen={isAnyDialogOpen}
              messageApprovalList={messageApprovalList}
              lrnFilter={lrnFilter}
              setOpenPenalClauseDialog={setOpenPenalClauseDialog}
              setOpenDsraClauseDialog={setOpenDsraClauseDialog}
              nonFinancialComplianceData={nonFinancialComplianceData}

            />
          </div>

          {
            chequeBounceList.length === 0 &&
            <EmptyListUI
              context={context}
              createEnabled={false}
              createDisabledMessageLabel='No Monitoring Intelligence Found'
            />
          }

          <MonitoringActionModalSF
            context={context}
            isUpdateMode={isUpdateMode}
            onCancelClick={onUpdateModeClose}
            onRefreshClick={onRefreshClick}
            currentItem={currentItem}
          />

          <EMIDetailsDialogUI
            isOpen={isEmiDetailsModalOpen}
            onClose={closeEmiDetailsModal}
            details={currentEmiDetails}
          />
          <LegalChargeDetailsDialogUI
            isOpen={isLegalDetailsModalOpen}
            onClose={closeLegalDetailsModal}
            details={currentLegalDetails}
          />
          <PenalChargeDialogUI
            isOpen={isPenalDetailModalOpen}
            onClose={closePenalDetailModal}
            details={currentPenalDetails}
          />
          <DsraDipDetailsDialogUI
            isOpen={isDsraDetailModalOpen}
            onClose={closeDsraDetailModal}
            details={currentDsraDetails}
          />
          <PenalChargeDetailsDialogUI
            isOpen={isPenalClauseModalOpen}
            onClose={closePenalClauseModal}
            details={currentPenalClauses}
          />
          <DsraClauseDialogUI
            isOpen={isDsraClauseModalOpen}
            onClose={closeDsraClauseModal}
            defaultReason={currentDsraClause}
          />

          <AccountSummaryDialog
            isOpen={isAccountSummaryOpen}
            onClose={closeAccountSummaryModal}
            summaryData={currentAccountSummary}
          />
          <NoticeCreationModal
            isOpen={isNoticeModalOpen}
            onClose={onCloseNoticeModal}
            onCreateNotice={onCreateNoticeDraft}
            messageType={noticeModalType}
            accountId={noticeModalAccountId}
            loading={noticeCreationLoading}
            context={context}
          />
        </div>
      }
    </SuperUserHomePageUI>
  )
}

const MonitoringIntelligenceTableUI = ({
  processedData, context, getStatusDisplayValue, onDocDownloadClick, onUpdateMode,
  onEmiDetailsClick, onCreateWhatsappApproval, onCreateEmailApproval, onViewAccountSummary, isAnyDialogOpen,
  messageApprovalList, lrnFilter, setOpenPenalClauseDialog, setOpenDsraClauseDialog, onLegalChargeDetailsClick, onPenalChargeDetailsClick,
  onDsraShortfallDetailsClick, nonFinancialComplianceData
}) => {
  const [sortType, setSortType] = useState('reset');
  const [expandedAccounts, setExpandedAccounts] = useState({});
  const [expandedNonFinancial, setExpandedNonFinancial] = useState({});
  const lrnDisplayTracker = {};
  const cleanNumber = (num) => {
    if (typeof num === "string") {
      return parseFloat(num.replace(/,/g, "")) || 0;
    }
    return Number(num) || 0;
  };

  const getMessageApprovalCounts = (accountId) => {
    if (!messageApprovalList || !accountId) return { whatsapp: 0, email: 0 };

    const normalizedAccountId = accountId ? accountId.toString().trim() : '';

    const filteredApprovals = messageApprovalList.filter(approval => {
      const approvalAccountId = approval.accountId ? approval.accountId.toString().trim() : '';
      return approvalAccountId === normalizedAccountId && approval.statusEnum === "success";
    });

    return {
      whatsapp: filteredApprovals.filter(a => a.messageApprovalType === "whatsapp").length,
      email: filteredApprovals.filter(a => a.messageApprovalType === "customerServiceEmail").length
    };
  };

  const hasSuccessfulNotices = (accountId) => {
    if (!messageApprovalList || !accountId) return false;

    const normalizedAccountId = accountId ? accountId.toString().trim() : '';

    return messageApprovalList.some(approval => {
      const approvalAccountId = approval.accountId ? approval.accountId.toString().trim() : '';
      return approvalAccountId === normalizedAccountId && approval.statusEnum === "success";
    });
  };
  const toggleNonFinancialCompliance = (accountName) => {
    setExpandedNonFinancial(prev => ({
      ...prev,
      [accountName]: !prev[accountName]
    }));
  };

  const handleViewAccountDetails = (accountName, summaryData) => {
    // Toggle the expanded state for this account
    setExpandedAccounts(prev => ({
      ...prev,
      [accountName]: !prev[accountName]
    }));

    // Call the original onViewAccountSummary function
    onViewAccountSummary(accountName, summaryData);
  };

  const accountGroups = {};
  const accountSummaries = {};

  useEffect(() => {
    if (processedData && processedData.length > 0) {
      const autoExpandedAccounts = {};
      processedData.forEach((row) => {
        autoExpandedAccounts[row.accountName] = true;
      });
      setExpandedAccounts(autoExpandedAccounts);
    }
  }, [processedData]);

  // Create a helper map for quick DSRA lookups
  const dsraShortfallMap = {};

  // First, extract all dsraShortfall entries into a map by accountName
  processedData.forEach((row) => {
    const { accountName, item } = row;

    if (item.reportType === "dsraShortfall") {
      dsraShortfallMap[accountName] = {
        dsra: cleanNumber(item.dsra ? item.dsra.toString() : "0"),
        dsraCur: cleanNumber(item.dsraCur ? item.dsraCur.toString() : "0"),
        dsraDip: cleanNumber(item.dsraDip ? item.dsraDip.toString() : "0")
      };
    }
  });

  // Now process the rows as usual
  processedData.forEach((row) => {
    const { accountName, item } = row;

    if (item.reportType === "emi" && (!item.lrn || item.lrn === "N/A")) {
      return;
    }

    if (!accountGroups[accountName]) accountGroups[accountName] = [];
    accountGroups[accountName].push(row);

    if (!accountSummaries[accountName]) {
      accountSummaries[accountName] = {
        totalAmountDue: 0,
        totalAmountReceived: 0,
        totalAmountPending: 0,
        totalOverdueInterest: 0,
        loans: {},
        accountId: item.accountId,
        dsraIncluded: false // <-- to prevent duplicate inclusion
      };
    }

    const isValidReportType = ["emi", "legalCharge", "penalCharge"].includes(item.reportType);

    if (isValidReportType) {
      accountSummaries[accountName].totalAmountDue += cleanNumber(item.amount);
      accountSummaries[accountName].totalAmountReceived += cleanNumber(item.amountReceived);
      accountSummaries[accountName].totalAmountPending += cleanNumber(item.amountPending);

      if (item.reportType === "emi") {
        accountSummaries[accountName].totalOverdueInterest += cleanNumber(item.overdueInterest);
      }
    }

    if (item.lrn && item.lrn !== "N/A") {
      if (!accountSummaries[accountName].loans[item.lrn]) {
        accountSummaries[accountName].loans[item.lrn] = {
          loanId: item.loanId,
          totalDue: 0,
          totalReceived: 0,
          totalPending: 0,
          totalOverdueInterest: 0
        };
      }

      if (isValidReportType) {
        accountSummaries[accountName].loans[item.lrn].totalDue += cleanNumber(item.amount);
        accountSummaries[accountName].loans[item.lrn].totalReceived += cleanNumber(item.amountReceived);
        accountSummaries[accountName].loans[item.lrn].totalPending += cleanNumber(item.amountPending);

        if (item.reportType === "emi") {
          accountSummaries[accountName].loans[item.lrn].totalOverdueInterest += cleanNumber(item.overdueInterest);
        }
      }
    }
  });

  // ✅ Add DSRA shortfall values only once per account
  Object.entries(dsraShortfallMap).forEach(([accountName, dsraData]) => {
    if (accountSummaries[accountName] && !accountSummaries[accountName].dsraIncluded) {
      accountSummaries[accountName].totalAmountDue += dsraData.dsra;
      accountSummaries[accountName].totalAmountReceived += dsraData.dsraCur;
      accountSummaries[accountName].totalAmountPending += dsraData.dsraDip;

      accountSummaries[accountName].dsraIncluded = true; // prevent duplication
    }
  });


  const filteredAccountSummaries = {};

  if (lrnFilter && lrnFilter.trim() !== '') {
    const normalizedLrnFilter = lrnFilter.trim().toLowerCase();

    Object.entries(accountGroups).forEach(([accountName, rows]) => {
      filteredAccountSummaries[accountName] = {
        totalAmountDue: 0,
        totalAmountReceived: 0,
        totalAmountPending: 0,
        totalOverdueInterest: 0,
        loans: {},
        accountId: accountSummaries[accountName].accountId
      };

      const filteredRows = rows.filter(row =>
        row.item.lrn &&
        row.item.lrn.toLowerCase().includes(normalizedLrnFilter)
      );

      filteredRows.forEach(row => {
        const { item } = row;
        const isValidReportType = ["emi", "legalCharge", "penalCharge", "dsraShortfall"].includes(item.reportType);

        if (isValidReportType) {
          filteredAccountSummaries[accountName].totalAmountDue += cleanNumber(item.amount);
          filteredAccountSummaries[accountName].totalAmountReceived += cleanNumber(item.amountReceived);
          filteredAccountSummaries[accountName].totalAmountPending += cleanNumber(item.amountPending);

          if (item.reportType === "emi") {
            filteredAccountSummaries[accountName].totalOverdueInterest += cleanNumber(item.overdueInterest);
          }
        }
      });
    });
  }

  let filteredAccountEntries = Object.entries(accountGroups);

  if (lrnFilter && lrnFilter.trim() !== '') {
    const normalizedLrnFilter = lrnFilter.trim().toLowerCase();

    filteredAccountEntries = filteredAccountEntries.filter(([accountName, rows]) => {
      return rows.some(row =>
        row.item.lrn &&
        row.item.lrn.toLowerCase().includes(normalizedLrnFilter)
      );
    });
  }

  const sortedAccountEntries = [...filteredAccountEntries];

  const summaryToUse = (lrnFilter && lrnFilter.trim() !== '')
    ? filteredAccountSummaries
    : accountSummaries;

  if (sortType === 'max') {
    sortedAccountEntries.sort((a, b) =>
      summaryToUse[b[0]].totalAmountPending - summaryToUse[a[0]].totalAmountPending
    );
  } else if (sortType === 'min') {
    sortedAccountEntries.sort((a, b) =>
      summaryToUse[a[0]].totalAmountPending - summaryToUse[b[0]].totalAmountPending
    );
  } else {
    sortedAccountEntries.sort((a, b) => a[0].localeCompare(b[0]));
  }

  return (
    <CardUI className='scard'>
      <div className="mi-sort-bar">
        <span className="mi-sort-label">Sort by Account Total:</span>
        <button
          className={`g_btn g_btn_outline mi-sort-btn${sortType === 'max' ? ' mi-sort-btn-active-max' : ''}`}
          onClick={() => setSortType('max')}
        >
          <span>▲ Max</span>
        </button>
        <button
          className={`g_btn g_btn_outline mi-sort-btn${sortType === 'min' ? ' mi-sort-btn-active-min' : ''}`}
          onClick={() => setSortType('min')}
        >
          <span>▼ Min</span>
        </button>
        <button
          className={`g_btn g_btn_outline mi-sort-btn${sortType === 'reset' ? ' mi-sort-btn-active-reset' : ''}`}
          onClick={() => setSortType('reset')}
        >
          <span>Reset</span>
        </button>
      </div>
      {/* Table wrapper with controlled overflow and positioning context */}
      <div className={`mi-table-wrapper ${isAnyDialogOpen ? 'dialog-open' : ''}`} style={{
        position: 'relative',
        maxHeight: '70vh',
        overflow: 'auto'
      }}>
        <table className='table_cr table'>
          {/* Fixed table header that stays visible during scroll */}
          <thead style={{
            position: isAnyDialogOpen ? 'static' : 'sticky',
            top: 0,
            zIndex: 100,
            backgroundColor: 'white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <tr>
              {/* Table contents */}
              <th>S.No</th>
              <th>Account</th>
              <th>LRN</th>
              <th>Type</th>
              <th>Amount Required/DSRA Required</th>
              <th>Amount Received/DSRA Current</th>
              <th>Amount Pending/DSRA Dip </th>
              <th>OverDue Interest</th>
              <th>Last Payment Date</th>
              <th>Date Of Default</th>
              <th>Cure Date</th>
              <th>Default Reason</th>
              <th>Status</th>
              <th>Monitoring Actions</th>
              <th>Monitoring Comment</th>
              <th>Files</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {sortedAccountEntries.length > 0 ? (
              sortedAccountEntries.map(([accountName, rows], accountIndex) => {
                const summary = (lrnFilter && lrnFilter.trim() !== '')
                  ? filteredAccountSummaries[accountName]
                  : accountSummaries[accountName];
                const accountId = summary.accountId;
                const isExpanded = expandedAccounts[accountName];
                const approvalCounts = getMessageApprovalCounts(accountId);
                const hasNotices = hasSuccessfulNotices(accountId);
                const isNonFinancialExpanded = expandedNonFinancial[accountName];
                const accountNonFinancialData = (nonFinancialComplianceData && nonFinancialComplianceData[accountName]) || [];

                const accountSummaryRow = [
                  <tr key={`summary-${accountName}`} className="g_account_summary_row">
                    <td className="g_text_left">{accountIndex + 1}</td>
                    <td className="g_text_left">
                      <div className="g_flex_v g_flex_left">
                        {/* Account Name */}
                        <div
                          className={`g_bold ${hasNotices ? 'g_text_danger' :
                            rows.some(row => row.item.reportType === "dsraShortfall") ? 'g_info' :
                              rows.every(row => row.item.reportType === "dsraShortfall" || row.item.closureStatus === "close") ? 'g_success' : ''}`}
                        >
                          {(() => {
                            const firstLoan = Object.values(summary.loans || {})[0];
                            const loanId = firstLoan ? firstLoan.loanId : null;

                            return loanId ? (
                              <Link
                                to={`/su/loans/${loanId}/bankAccounts`}
                                className="g_link"
                                style={{ color: '#65BDF0' }}
                              >
                                {accountName}
                              </Link>
                            ) : (
                              <span>{accountName}</span>
                            );
                          })()}
                        </div>

                        {/* Arrow icon for non-financial compliance (hover shows label) */}
                        {/* {accountNonFinancialData.length > 0 && (
                          <span
                            className="g_cursor_pointer g_m_top_5"
                            onClick={() => toggleNonFinancialCompliance(accountName)}
                            style={{
                              fontSize: '16px',
                              color: '#666',
                              display: 'inline-block',
                              position: 'relative'
                            }}
                            title="Show Non-Financial Compliances of Account"
                          >
                            {isNonFinancialExpanded ? '▲' : '▼'}
                          </span>
                        )} */}
                      </div>

                    </td>
                    <td colSpan={2} className="g_text_center g_bold" style={{ color: '#80154a' }}>
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      {summary.totalAmountDue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      {summary.totalAmountReceived.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      {summary.totalAmountPending.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      -
                    </td>
                    <td colSpan={8}></td>
                    <td className="g_text_left">
                      <div className="g_flex_h g_flex_middle">
                        <div className="g_flex_v g_m_right_15">
                          <button
                            onClick={() => onCreateWhatsappApproval(accountId)}
                            className="g_icon_button g_m_right_5 whatsapp-button"
                            title="Create WhatsApp message approval"
                          >
                            <img src={whatsappIcon} alt="WhatsApp" width="20" height="20" />
                          </button>
                          {approvalCounts.whatsapp > 0 && (
                            <div className="g_text_small g_text_center message-count-indicator g_text_danger">
                              <strong>Sent: {approvalCounts.whatsapp}</strong>
                            </div>
                          )}
                        </div>

                        <div className="g_flex_v">
                          <IconButtonUI
                            icon='icon-envelope'
                            onClick={() => onCreateEmailApproval(accountId)}
                            label="Create Email message approval"
                          />
                          {approvalCounts.email > 0 && (
                            <div className="g_text_small g_text_center message-count-indicator g_text_danger">
                              <strong>Sent: {approvalCounts.email}</strong>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ];

                const loanDetailRows = [];
                const nonFinancialRows = [];
                if (isNonFinancialExpanded && accountNonFinancialData.length > 0) {
                  // Group compliances by LRN
                  const groupedByLRN = accountNonFinancialData.reduce((acc, item) => {
                    if (!acc[item.lrn]) acc[item.lrn] = [];
                    acc[item.lrn].push(item);
                    return acc;
                  }, {});

                  // Filter compliances to include only those with status === 'not_complied'
                  const filteredCompliances = accountNonFinancialData.filter(
                    (compliance) => compliance.status === 'not_complied'
                  );

                  if (filteredCompliances.length > 0) {
                    nonFinancialRows.push(
                      <tr key={`nfc-header-${accountName}`} className="g_non_financial_header">
                        <td colSpan="17" style={{ padding: '0', backgroundColor: '#f5f5f5' }}>
                          <div style={{ padding: '15px' }}>
                            <div className="g_bold g_m_bottom_10" style={{ fontSize: '14px', color: '#333' }}>
                              Non-Financial Compliances
                            </div>
                            <table className="table_cr table" style={{ width: '100%', marginBottom: '0' }}>
                              <thead style={{ backgroundColor: '#e8e8e8' }}>
                                <tr>
                                  <th style={{ width: '15%' }}>LRN</th>
                                  <th style={{ width: '15%' }}>Report Type</th>
                                  <th style={{ width: '30%' }}>Default Reason</th>
                                  <th style={{ width: '15%' }}>Monitoring Action</th>
                                  <th style={{ width: '25%' }}>Monitoring Comment</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.entries(groupedByLRN).map(([lrn, compliances]) => (
                                  compliances
                                    .filter(c => c.status === 'not_complied')
                                    .map((compliance, index) => (
                                      <tr key={`nfc-row-${accountName}-${lrn}-${index}`} style={{ backgroundColor: 'white' }}>
                                        {index === 0 && (
                                          <td
                                            className="g_text_left"
                                            rowSpan={compliances.filter(c => c.status === 'not_complied').length}
                                          >
                                            {lrn || 'N/A'}
                                          </td>
                                        )}
                                        <td className="g_text_left">
                                          {compliance.reportType === 'nonFinancial'
                                            ? 'Non Finance'
                                            : (compliance.reportType || 'N/A')}
                                        </td>
                                        <td className="g_text_left">
                                          <div className="g_flex_v">
                                            <div className="g_bold">{compliance.complianceTitle || 'N/A'}</div>
                                            <div className="g_small g_muted">{compliance.clause || 'N/A'}</div>
                                          </div>
                                        </td>
                                        <td className="g_text_left">
                                          {(compliance.monitoringAction && compliance.monitoringAction.trim()) || 'Not set'}
                                        </td>
                                        <td className="g_text_left">
                                          <div className="g_flex_h g_flex_middle">
                                            <span>
                                              {(compliance.monitoringComment && compliance.monitoringComment.trim()) || 'Not set'}
                                            </span>
                                            <span
                                              className="icon icon-pencil g_cursor_pointer g_muted g_m_left_10"
                                              onClick={() =>
                                                onUpdateMode({
                                                  ...compliance,
                                                  reportType: 'nonFinancial'
                                                })
                                              }
                                              style={{ verticalAlign: 'top' }}
                                            ></span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))
                                ))}

                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                }

                if (isExpanded) {
                  const reportTypeOrder = {
                    dsraShortfall: 1,
                    emi: 2,
                    penalCharge: 3,
                    nachFailure: 4,
                    loanChequeBounce: 5,
                    nachFailure: 6,
                  };

                  // Sort the rows by report type
                  const sortedRows = [...rows].sort((a, b) => {
                    const aOrder = reportTypeOrder[a.item.reportType] || 99;
                    const bOrder = reportTypeOrder[b.item.reportType] || 99;
                    return aOrder - bOrder;
                  });

                  // Filter rows by LRN if lrnFilter is present
                  const filteredRows = lrnFilter && lrnFilter.trim() !== ''
                    ? sortedRows.filter(row =>
                      row.item.lrn &&
                      row.item.lrn.toLowerCase().includes(lrnFilter.trim().toLowerCase())
                    )
                    : sortedRows;

                  // Reset the LRN display tracker for filtered view
                  if (lrnFilter && lrnFilter.trim() !== '') {
                    Object.keys(lrnDisplayTracker).forEach(key => {
                      if (key.startsWith(accountName)) {
                        delete lrnDisplayTracker[key];
                      }
                    });
                  }

                  const lrnGroupedRows = {};

                  filteredRows.forEach((row) => {
                    const lrn = row.item.lrn || 'N/A';
                    if (!lrnGroupedRows[lrn]) {
                      lrnGroupedRows[lrn] = [];
                    }
                    lrnGroupedRows[lrn].push(row);
                  });

                  Object.entries(lrnGroupedRows).forEach(([lrn, lrnRows], lrnIndex) => {
                    let shouldDisplayLrn = true;

                    const reportTypeOrder = {
                      dsraShortfall: 1,
                      emi: 2,
                      penalCharge: 3,
                      nachFailure: 4,
                      loanChequeBounce: 5,
                      legalCharge: 6
                    };

                    lrnRows.sort((a, b) => {
                      const aOrder = reportTypeOrder[a.item.reportType] || 99;
                      const bOrder = reportTypeOrder[b.item.reportType] || 99;
                      return aOrder - bOrder;
                    });

                    lrnRows.forEach((row, index) => {
                      const { item } = row;
                      const isNachFailure = item.reportType === "nachFailure";
                      const isLegalCharge = item.reportType === "legalCharge";
                      const isPenalCharge = item.reportType === "penalCharge";
                      const isDsraShortfall = item.reportType === "dsraShortfall";
                      const isEmi = item.reportType === "emi";
                      const isLoanChequeBounce = item.reportType === "chequeBounce";

                      loanDetailRows.push(
                        <tr
                          key={`entry-${accountName}-${lrn}-${index}`}
                        >
                          <td className="g_text_left"></td>
                          <td className="g_text_left"></td>
                          <td className="g_text_left">
                            {shouldDisplayLrn ? (
                              isNachFailure ? (
                                <span>{item.escAccountNumber || 'N/A'}</span>
                              ) : isDsraShortfall ? (
                                <span>N/A</span>
                              ) : (
                                <span>{item.lrn}</span>
                              )
                            ) : ''}
                          </td>

                          <td className="g_text_left">
                            <div>
                              {isNachFailure ? <Link to={`/su/accounts/${item.accountId}/nachFailure`} className="g_link">NACH Failure*</Link> :
                                isLegalCharge ? <Link to={`/su/loans/${item.loanId}/fees`} className="g_link">Legal Charge</Link> :
                                  isPenalCharge ? <Link to={`/su/loans/${item.loanId}/repayments/v2`} className="g_link">Penal Charge</Link> :
                                    isDsraShortfall ? <Link to={`/su/loans/${item.loanId}/bankAccounts`} className="g_link">DSRA Shortfall</Link> :
                                      isEmi ? <Link to={`/su/loans/${item.loanId}/bankAccounts`} className="g_link">EMI</Link> :
                                        isLoanChequeBounce ? <Link to={`/su/loans/${item.loanId}/loanCheque`} className="g_link">Cheque Bounce</Link> :
                                          item.reportType}
                            </div>
                          </td>

                          <td className="g_text_left">
                            {item.amount || '-'}
                          </td>
                          <td className="g_text_left">{item.amountReceived || '0'}</td>
                          <td className="g_text_left">
                            {(isEmi || isLegalCharge || isPenalCharge) && item.details ? (
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (isEmi) {
                                    onEmiDetailsClick(item.details);
                                  } else if (isLegalCharge) {
                                    onLegalChargeDetailsClick(item.details);
                                  } else if (isPenalCharge) {
                                    onPenalChargeDetailsClick(item.details);
                                  }
                                  // else if (isDsraShortfall) {
                                  //   onDsraShortfallDetailsClick(item.details);
                                  // }
                                }}
                                className="g_link"
                              >
                                {item.amountPending || '0'}
                              </a>
                            ) : (
                              `${item.amountPending || '0'}`
                            )}
                          </td>


                          <td className="g_text_left">
                            {isEmi ? ` ${item.overdueInterest || '0'}` : '-'}
                          </td>
                          <td className="g_text_left">{item.lastPaymentDate || '-'}</td>
                          <td className="g_text_left">
                            {isNachFailure ? (item.defaultDate || '-') :
                              isLegalCharge ? (item.defaultDate || '-') :
                                isEmi ? (item.defaultDate || '-') :
                                  isLegalCharge ? (item.defaultDate || '-') :
                                    isPenalCharge ? (item.defaultDate || '-') :
                                      isDsraShortfall ? (item.defaultDate || '-') :
                                        item.bounceDate || '-'}
                          </td>
                          <td className="g_text_left">{item.cureDate || '-'}</td>
                          <td className="g_text_left">
                            {isNachFailure ? (
                              <>
                                <div>{item.reasonDescription || '-'}</div>
                              </>
                            ) : isLegalCharge ? (item.defaultReason) :
                              isEmi ? (item.defaultReason || 'EMI Default') : isDsraShortfall ? (
                                <a
                                  href="#"
                                  className="g_link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setOpenDsraClauseDialog(item.defaultReason);
                                  }}
                                >
                                  Compliance
                                </a>
                              ) :
                                isPenalCharge ? (
                                  <a
                                    href="#"
                                    className="g_link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setOpenPenalClauseDialog(item.defaultReason);
                                    }}
                                  >
                                    Compliance
                                  </a>
                                )

                                  :
                                  (
                                    item.bounceReason || '-'
                                  )}
                          </td>
                          <td className="g_text_left">{getStatusDisplayValue(item.closureStatus)}</td>
                          <td className="g_text_left">
                            <div className="g_flex_h g_flex_middle">
                              <span>
                                {item.monitoringAction && item.monitoringAction.trim() !== ''
                                  ? item.monitoringAction
                                  : 'Not set'}
                              </span>
                              {/* Removed pencil icon here */}
                            </div>
                          </td>
                          <td className="g_text_left">
                            <div className="g_flex_h g_flex_middle">
                              <span>
                                {item.monitoringComment && item.monitoringComment.trim() !== ''
                                  ? item.monitoringComment
                                  : 'Not set'}
                              </span>
                              <span
                                className="icon icon-pencil g_cursor_pointer g_muted g_m_left_10"
                                onClick={() => onUpdateMode(item)}
                                data-object-id={item.objectId}
                                data-date={item.miActionCommentDateCreated}
                                data-remarks={item.monitoringComment}
                                style={{ verticalAlign: 'top' }}
                              ></span>
                            </div>
                          </td>
                          <td className="g_text_left">
                            {isNachFailure ? (
                              item.fileName ? (
                                <div className='g_flex_left g_flex_h'>
                                  1.&nbsp;
                                  <Link
                                    to="#"
                                    onClick={onDocDownloadClick}
                                    data-loan-id={item.loanId}
                                    data-file-name={item.fileName}
                                    className='g_link'
                                  >
                                    {item.fileName}
                                  </Link>
                                </div>
                              ) : (
                                'No files'
                              )
                            ) : isLoanChequeBounce ? (
                              item.fileUploadList && item.fileUploadList.length > 0 ? (
                                item.fileUploadList.map((fileName, index) => (
                                  <div key={index} className='g_flex_left g_flex_h'>
                                    {index + 1}.&nbsp;
                                    <Link
                                      to="#"
                                      onClick={onDocDownloadClick}
                                      data-loan-id={item.loanId}
                                      data-file-name={fileName}
                                      className='g_link'
                                    >
                                      {fileName}
                                    </Link>
                                  </div>
                                ))
                              ) : (
                                'No files'
                              )
                            ) : (
                              '-'
                            )}
                          </td>
                          <td className="g_text_left">
                          </td>
                        </tr>
                      );
                      shouldDisplayLrn = false;
                    });
                  });
                }

                return [accountSummaryRow, ...nonFinancialRows, ...loanDetailRows];
              }).flat()
            ) : (
              <tr>
                <td colSpan="17" className="g_text_center">
                  <EmptyListUI
                    context={context}
                    createEnabled={false}
                    createDisabledMessageLabel='No Monitoring Intelligence Found'
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </CardUI>
  );
};

export default MonitoringIntelligenceRetailUI;